/**
 * Name of Background Shape
 */
export const BACKGROUND_SHAPE = 'element-background';
